<!--设置司机-->
<template>
  <el-dialog
    ref="driverinfo"
    title="设置司机信息"
    :visible.sync="visible"
    :append-to-body="true"
    width="66%"
  >
    <el-form
      ref="query"
      :model="query"
      :inline="true"
      size="small"
      label-width="88px"
      @submit.native.prevent
    >
      <el-form-item label="司机信息" prop="searchKey">
        <el-input v-model="query.searchKey" clearable placeholder="搜索司机及车牌信息" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click.stop="search">搜索</el-button>
        <el-button type="danger" @click.stop="reset">清空</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="data"
      stripe
      highlight-current-row
      border
      max-height="300px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center" width="55" />
      <el-table-column label="司机" align="center">
        <template slot-scope="scope">
          {{ scope.row.driverName + ' ' + scope.row.driverPhone }}
        </template>
      </el-table-column>
      <el-table-column label="车牌" align="center" prop="carNumber" />
      <el-table-column label="车型" align="center" prop="seats" />
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="page.current"
      :limit.sync="page.size"
      @pagination="refresh"
    />
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getDriver } from '@/api/transport/bustime'
  export default {
    name: 'setDriver',
    data() {
      return {
        visible: false,
        query: {
          searchKey: ''
        },
        page: {
          current: 1,
          size: 10
        },
        total: 0,
        items: [],
        data: [],
        tableIndex: '',
        form: {
          tableIndex: ''
        },
        selections: [],
        batchDriver: ''
      }
    },
    methods: {
      init(index, row, merchantId, batchDriver) {
        this.visible = true
        this.batchDriver = batchDriver
        if (index === 9999) {
          this.query = {
            merchantId,
            priceMethodId: row
          }
          this.onLoad()
          return
        }
        this.form = row
        this.data = []
        this.form.tableIndex = index
        this.query = {
          merchantId,
          priceMethodId: row.priceMethodId
        }
        this.onLoad()
      },
      search() {
        this.page.current = 1
        this.onLoad()
      },
      refresh() {
        this.onLoad()
      },
      reset() {
        this.$refs.query.resetFields()
        this.onLoad()
        // this.data = []
      },
      async onLoad() {
        const adOndata = {
          current: this.page.current,
          size: this.page.size,
          ...this.query,
          lineId: this.$route.params && this.$route.params.lineId
        }
        await getDriver(adOndata).then((resp) => {
          this.data = resp.data.records
          this.total = resp.data.total
        })
      },
      handleSelectionChange(arry) {
        if (arry) {
          this.selections = arry
        }
      },
      save() {
        // this.data = []
        // eslint-disable-next-line eqeqeq
        if (this.selections.length == 0) {
          this.$message.warning('请选择司机')
          return
        }
        if (this.selections.length > 1 && !this.batchDriver) {
          this.$message.warning('只能选择一位司机')
          return
        }
        if (this.batchDriver) {
          this.form = this.selections
          this.$emit('DriverFormData', this.form)
          this.visible = false
          this.reset()
          return
        }
        this.form.driverInfo = this.selections[0].driverName + ' ' + this.selections[0].driverPhone
        this.form.driverId = this.selections[0].driverId
        this.form.carId = Number.parseInt(this.selections[0].carId)
        if (!this.form.tableIndex) {
          this.$emit('DriverFormData', this.form)
          this.visible = false
          this.reset()
          return
        }
        this.$emit('DriverFormData', this.form)
        this.visible = false
        this.reset()
      },
      cancel() {
        this.$refs.query.resetFields()
        this.visible = false
      }
    }
  }
</script>

<style scoped></style>
